<button mat-flat-button [color]="color" [attr.aria-label]="label" (click)="clicked()" [disabled]="disabled || (showSpinner$ | async)">
  @if (showSpinner$ | async) {
    <mat-spinner diameter="20"></mat-spinner>
  } @else {
    {{label}}
  }
</button>
